// extracted by mini-css-extract-plugin
module.exports = {"post":"Post_post__3hqZB","title":"Post_title__14e0g","postControls":"Post_postControls__2zqKe","author":"Post_author__3xUYm","content":"Post_content__3qstI"};